import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminLeads() {
    const [leads, setLeads] = useState([]);

    useEffect(() => {
        api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => {});
    }, []);

    function exportCsv() {
        const headers = ["Created", "Name", "Email", "Company", "Phone", "Download"];
        const rows = leads.map((l) => [
            new Date(l.created_at).toISOString(),
            l.name,
            l.email,
            l.company,
            l.phone,
            l.download_title,
        ]);
        const csv = [headers, ...rows].map((r) => r.map((c) => `"${(c || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `peppa-leads-${Date.now()}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    }

    return (
        <div className="p-8" data-testid="admin-leads">
            <div className="flex items-center justify-between mb-1">
                <h1 className="font-display text-3xl font-bold">Leads (download gate)</h1>
                <button onClick={exportCsv} disabled={!leads.length} className="bg-primary text-white px-4 py-2 text-sm font-semibold disabled:opacity-50" data-testid="export-csv-btn">
                    Export CSV
                </button>
            </div>
            <p className="text-sm text-muted-foreground mb-8">{leads.length} captured lead{leads.length !== 1 ? 's' : ''}</p>
            <div className="bg-white border border-border overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-muted text-left"><tr>
                        <th className="px-4 py-3">Date</th><th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Company</th><th className="px-4 py-3">Phone</th><th className="px-4 py-3">Downloaded</th>
                    </tr></thead>
                    <tbody>
                        {leads.map((l) => (
                            <tr key={l.id} className="border-t border-border">
                                <td className="px-4 py-3 text-xs">{new Date(l.created_at).toLocaleString()}</td>
                                <td className="px-4 py-3 font-semibold">{l.name}</td>
                                <td className="px-4 py-3">{l.email}</td>
                                <td className="px-4 py-3">{l.company || '—'}</td>
                                <td className="px-4 py-3 text-xs">{l.phone || '—'}</td>
                                <td className="px-4 py-3 text-xs">{l.download_title}</td>
                            </tr>
                        ))}
                        {leads.length === 0 && (
                            <tr><td colSpan="6" className="text-center py-12 text-muted-foreground">No leads captured yet. They'll appear when visitors download files via the lead-gate.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
